// extracted by mini-css-extract-plugin
export default {"wrapper":"bYUpxVq5GcGMyvxefvxdyA==","wrapper--small":"m1EvGyix50SMo9SGctEj4A==","wrapper--medium":"_5uBJP46TBgZTm48l-COOCg==","wrapper--big":"CldVzKrPdu0ZkebTOmhu8Q=="};